// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.skl-header {
  margin-bottom: 20px;
}

.skl-toolbar {
  margin-bottom: 20px;
}

.skl-card {
  margin-bottom: 20px;
  border: 1px solid #dee2e6;
  border-radius: 4px;
  background: #fff;
}

.skl-card__body {
  padding: 20px;
}

.skl-table-wrap {
  border: 1px solid #edf0f2;
  border-radius: 4px;
  overflow: hidden;
}

.skl-table {
  width: 100%;
  min-width: 980px;
  border-collapse: separate;
  border-spacing: 0;
  table-layout: fixed;
}

.skl-table th,
.skl-table td {
  padding: 10px 12px;
  min-width: 0;
  text-align: left;
  vertical-align: middle;
  white-space: nowrap;
}

.skl-table thead th {
  height: 56px;
  background: #f8f9fa;
  border-bottom: 1px solid #edf0f2;
}

.skl-table__filters th {
  height: 48px;
}

.skl-table tbody td {
  height: 48px;
  border-bottom: 1px solid #edf0f2;
}

.skl-table tbody tr:last-child td {
  border-bottom: none;
}

.skl-actions-inline {
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}

.skl-total-count {
  display: flex;
  justify-content: flex-end;
  margin-top: 16px;
}

.skl-pagination {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 18px;
}

.skl-page-size {
  display: flex;
  align-items: center;
  gap: 10px;
}

.skl-pagination__buttons {
  display: flex;
  gap: 4px;
}

@media (max-width: 575.98px) {
  .skl-pagination {
    flex-wrap: wrap;
    justify-content: flex-start;
    gap: 12px;
  }
  .skl-page-size {
    flex-wrap: wrap;
  }
}`, "",{"version":3,"sources":["webpack://./projects/ai_modernization/src/app/admin/platformmaster/platform-master-skeleton/platform-master-skeleton.component.scss"],"names":[],"mappings":"AAAA;EACE,mBAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,mBAAA;EACA,yBAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;AACF;;AAEA;EACE,yBAAA;EACA,kBAAA;EACA,gBAAA;AACF;;AAEA;EACE,WAAA;EACA,gBAAA;EACA,yBAAA;EACA,iBAAA;EACA,mBAAA;AACF;;AAEA;;EAEE,kBAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,mBAAA;AACF;;AAEA;EACE,YAAA;EACA,mBAAA;EACA,gCAAA;AACF;;AAEA;EACE,YAAA;AACF;;AAEA;EACE,YAAA;EACA,gCAAA;AACF;;AAEA;EACE,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,QAAA;EACA,mBAAA;AACF;;AAEA;EACE,aAAA;EACA,yBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,gBAAA;AACF;;AAEA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AACF;;AAEA;EACE,aAAA;EACA,QAAA;AACF;;AAEA;EACE;IACE,eAAA;IACA,2BAAA;IACA,SAAA;EACF;EAEA;IACE,eAAA;EAAF;AACF","sourcesContent":[".skl-header {\n  margin-bottom: 20px;\n}\n\n.skl-toolbar {\n  margin-bottom: 20px;\n}\n\n.skl-card {\n  margin-bottom: 20px;\n  border: 1px solid #dee2e6;\n  border-radius: 4px;\n  background: #fff;\n}\n\n.skl-card__body {\n  padding: 20px;\n}\n\n.skl-table-wrap {\n  border: 1px solid #edf0f2;\n  border-radius: 4px;\n  overflow: hidden;\n}\n\n.skl-table {\n  width: 100%;\n  min-width: 980px;\n  border-collapse: separate;\n  border-spacing: 0;\n  table-layout: fixed;\n}\n\n.skl-table th,\n.skl-table td {\n  padding: 10px 12px;\n  min-width: 0;\n  text-align: left;\n  vertical-align: middle;\n  white-space: nowrap;\n}\n\n.skl-table thead th {\n  height: 56px;\n  background: #f8f9fa;\n  border-bottom: 1px solid #edf0f2;\n}\n\n.skl-table__filters th {\n  height: 48px;\n}\n\n.skl-table tbody td {\n  height: 48px;\n  border-bottom: 1px solid #edf0f2;\n}\n\n.skl-table tbody tr:last-child td {\n  border-bottom: none;\n}\n\n.skl-actions-inline {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  white-space: nowrap;\n}\n\n.skl-total-count {\n  display: flex;\n  justify-content: flex-end;\n  margin-top: 16px;\n}\n\n.skl-pagination {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  margin-top: 18px;\n}\n\n.skl-page-size {\n  display: flex;\n  align-items: center;\n  gap: 10px;\n}\n\n.skl-pagination__buttons {\n  display: flex;\n  gap: 4px;\n}\n\n@media (max-width: 575.98px) {\n  .skl-pagination {\n    flex-wrap: wrap;\n    justify-content: flex-start;\n    gap: 12px;\n  }\n\n  .skl-page-size {\n    flex-wrap: wrap;\n  }\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
